import htmlIndexTemplate from './index.html'
import './demo.css'

export function showLayoutDemo () {
  document.body.innerHTML = htmlIndexTemplate
}
